import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=162a5147&scoped=true"
import script from "./Products.vue?vue&type=script&lang=ts&setup=true"
export * from "./Products.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Products.vue?vue&type=style&index=0&id=162a5147&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a5147",
  null
  
)

export default component.exports